// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import React from "react"
import type { ChangelogMessage } from "@/views/home/component.changelogModal"
import { latestChangelogId } from "./changelogMeta"

// changelogMessages[0] is always the most recent release; useChangelog compares
// its id against lastChangelogMessageSeen to decide whether to show the modal.
// The top entry's id is sourced from latestChangelogId (changelogMeta.ts) so
// the E2E fixture's "already seen" seed can never drift from it. When adding a
// newer entry, move the id in both files together.
export const changelogMessages: ChangelogMessage[] = [
  {
    id: latestChangelogId,
    content: (
      <div>
        <h3 style={{ color: "#FFF", marginBottom: "1em" }}>
          Live cycle dashboard
        </h3>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          <li style={{ marginBottom: "0.5em" }}>
            <strong>Live refresh</strong> — the dashboard now polls itself
            while a cycle runs and stops automatically once it finishes.
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            <strong>Budget-burn gauge</strong> — spent vs. budget and burn
            rate, so you can see how close a cycle is to its stopping
            criterion.
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            <strong>Cycle Health panel</strong> — a one-look verdict
            (Healthy / Degraded / Stalled / Failing) with top errors and
            retry pressure.
          </li>
          <li style={{ marginBottom: "0.5em" }}>
            <strong>Curated events feed</strong> — milestones and real
            failures, with retries collapsed instead of drowning the
            story.
          </li>
        </ul>
      </div>
    ),
  },
]
